import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";

const Brand = () => {
  return (
    <div>
      <div className="brand">
        <Swiper
          spaceBetween={20}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            480: {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            820: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            912: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper  overflow-hidden"
        >
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-5.png"
              alt="logo"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-3.png"
              alt="logo"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-4.png"
              alt="logo"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-5.png"
              alt="logo"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-6.png"
              alt="logo"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-3.png"
              alt="logo"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-5.png"
              alt="logo"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-4.png"
              alt="logo"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="w-50 d-flex mx-auto"
              src="images/brand/brand-6.png"
              alt="logo"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default Brand;
